module.exports = __webpack_public_path__ + "static/media/adaptationPlan.forNewEmployee.7ebb85ca.svg";